import React, { useEffect, useRef, useState } from "react";
import Attachments from "../../../../components/Attachments/Attachments";
import Notifications from "../../../../components/Notifications/Notifications";
import { IoMdNotificationsOutline } from "react-icons/io";
import { useStateValue } from "../../../../StateProvider";
import { useForm } from "react-hook-form";
import {
  addSubTask,
  editeUser,
  getSignupReDetail,
  getSubTask,
  getSubTaskOrdNo,
  signup,
  updateSubTask,
} from "../../../../apiCall";
import toast from "react-hot-toast";
import { DateToYYYYMMDD } from "../../../../utils/FormateDate";
import { ExtractDays } from "../../../../utils/ExtractDays";
import { useNavigate, useParams } from "react-router-dom";
import DecodeAprxDuration from "../../../../utils/DecodeAprxDuration";
import EncodeAprxDuration from "../../../../utils/EncodeAprxDuration";
import Attachment from "../../../Attachment/Attachment";
import { validateNoBlankSpaces } from "../../../../utils/formValidation";

const AddUpdateSubTask = ({ setActiveTab, editSubTaskData }) => {
  const [tab, setTab] = useState("information");
  const [, dispatch] = useStateValue();
  const { temId, subtaskId, projectId, pName, tName } = useParams();
  const [templateID, setTemplateId] = useState("");
  const [projectName, setProjectName] = useState("");
  const [taskName, setTaskName] = useState("");
  const navigate = useNavigate();

  //******************************************attachment start **************************************************
  const [attachmentCount, setAttachmentCount] = useState(0);
  const [isAddAttachments, setIsAddAttachments] = useState(false);
  const [title, setTitle] = useState("Add Sub-Task");
  const formRef = useRef(null);
  const updateUrl = (newPath) => {
    const currentUrl = new URL(window.location.href);
    const searchParams = new URLSearchParams(currentUrl.search);

    // Construct new URL
    // const newPath = '/update/task/31';
    const newUrl = `${newPath}?${searchParams.toString()}`;

    // Navigate to the new URL
    navigate(newUrl);
  };

  const handleExternalSubmit = () => {
    if (tab === "information") {
      setIsAddAttachments(true);
      if (formRef.current) {
        setTimeout(() => {
          formRef.current.dispatchEvent(
            new Event("submit", { cancelable: true, bubbles: true })
          );
        }, 100);
      }
    } else {
      setTab("attachments");
      setTitle(
        projectId ? "Update SubTask Template Form" : "Add SubTask Template Form"
      );
    }
  };
  useEffect(() => {
    if (subtaskId && tab === "information") {
      setTitle("Update SubTask Template Form");
    }
    if (!subtaskId && tab === "information") {
      setTitle("Add SubTask Template Form");
    }
  }, [subtaskId]);
  //******************************************attachment end **************************************************
  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      AprxDays: 0,
      AprxHours: 0,
      AprxMinutes: 0,
    },
  });
  const onSubmit = async (data) => {
    if (
      // (parseInt(data?.AprxDays) === 0 || data?.AprxDays === "") &&
      // (parseInt(data?.AprxMinutes) === 0 || data?.AprxMinutes === "") &&
      // (parseInt(data?.AprxHours) === 0 || data?.AprxHours === "")
      false
    ) {
      toast.error("Days and hours cannot both be 0.");
    } else {
      dispatch({ type: "SET_LOADING", status: true });
      const totalDays = EncodeAprxDuration(
        data?.AprxDays === "" ? 0 : data?.AprxDays,
        data?.AprxHours === "" ? 0 : data?.AprxHours,
        data?.AprxMinutes === "" ? 0 : data?.AprxMinutes
      );
      data.AprxDuration = totalDays;
      if (data.OrdNo === "") {
        delete data.OrdNo;
      }
      delete data.AprxDays;
      delete data.AprxHours;
      delete data.AprxMinutes;
      if (subtaskId) {
        const re = await updateSubTask(subtaskId, data);
        if (re?.status === 200) {
          // navigate(`/update/task-template/${data?.TaskTmplID}`);
          if (isAddAttachments) {
            setTab("attachments");
            setTitle(
              subtaskId
                ? "Update SubTask Template Form"
                : "Add SubTask Template Form"
            );
            setIsAddAttachments(false);
          } else {
            navigate(
              `/update/task-template/${templateID}?subTaskId=${subtaskId}`
            );
            reset();
          }
          toast.success(re?.data?.message);
        } else if(re?.response) {
          toast.error(re?.response?.data?.message);
        }
      } else {
        const re = await addSubTask(data);
        if (re?.status === 201) {
          if (isAddAttachments) {
            setTab("attachments");
            updateUrl(`/update/subtask/${re?.data?.data?.ID}`);
            setTitle(
              subtaskId ? "Update SubTask Template Form" : "Add SubTask Template Form"
            );

            setIsAddAttachments(false);
          } else {
            navigate(
              `/update/task-template/${data?.TaskTmplID}?subTaskId=${re.data.data.ID}`
            );
            reset();
          }
          toast.success(re?.data?.message);
        } else if(re?.response) {
          toast.error(re?.response?.data?.message);
        }
      }
      dispatch({ type: "SET_LOADING", status: false });
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      dispatch({ type: "SET_LOADING", status: true });
      const re = await getSubTask(subtaskId);
      if (re?.status === 200) {
        console.log(re.data);
        setValue("TaskTmplID", re.data?.TaskTmplID);
        setTemplateId(re.data?.TaskTmplID);
        setValue("OrdNo", re.data?.OrdNo);
        setValue("Name", re.data?.Name);
        setValue("Dscr", re.data?.Dscr);
        setAttachmentCount(re.data?.attachments_no);

        const [days, hours, minutes] = DecodeAprxDuration(
          re?.data?.AprxDuration
        );
        setValue("AprxDays", days);
        setValue("AprxHours", hours);
        setValue("AprxMinutes", minutes);
        setProjectName(re.data?.parent_project_template_name);
        setTaskName(re.data?.parent_task_template_name);
      } else if(re?.response) {
        toast.error(re?.response?.data?.message);
      }
      dispatch({ type: "SET_LOADING", status: false });
    };
    if (subtaskId) {
      fetchData();
    }
  }, [subtaskId]);

  useEffect(() => {
    if (temId) {
      setValue("TaskTmplID", temId);
      setTemplateId(temId);
    }
    if (pName) {
      setProjectName(pName);
    }
    if (tName) {
      setTaskName(tName);
    }
  }, [temId, tName, pName]);

  useEffect(() => {
    const fetchData = async () => {
      dispatch({ type: "SET_LOADING", status: true });

      try {
        if (temId) {
          const re = await getSubTaskOrdNo(temId);
          if (re?.status === 200) {
            setValue("OrdNo", parseInt(re?.data?.data));
          } else if(re?.response) {
            toast.error(re?.response?.data?.message);
          }
        }
      } catch {}
      dispatch({ type: "SET_LOADING", status: false });
    };
    fetchData();
  }, [temId]);

  return (
    <div id="app-content">
      {/* Container fluid */}
      <div className="app-content-area mb-10">
        <div className="container-fluid ">
          <div className= "mx-n6 mt-n6 pt-6 mb-6 header">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-12">
                {/* Page header */}
                <div
                  className="d-lg-flex
          align-items-center justify-content-between  px-6"
                >
                  <div className="mb-6 mb-lg-0">
                    <div className="d-flex align-items-center">
                      <div className="">
                        <h1 className="mb-0 h3 ">
                          {title}

                          {/* {subtaskId ? "Update" : "Add"} SubTask Template Form */}
                        </h1>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  {/* nav  */}
                  <ul className="nav nav-lb-tab px-6">
                    <li className="nav-item ms-0 me-3">
                      <div
                        role="button"
                        // className="nav-link active "
                        className={`${
                          tab === "information"
                            ? "nav-link active "
                            : "nav-link"
                        }`}
                        onClick={() => {
                          setTab("information");
                          setTitle(
                            subtaskId
                              ? "Update SubTask Template Form"
                              : "Add SubTask Template Form"
                          );
                        }}
                      >
                        Information
                      </div>
                    </li>
                    <li className="rounded-circl notification-count nav-item mx-3">
                      <div
                        role="button"
                        className={`${
                          tab === "attachments"
                            ? "nav-link active "
                            : "nav-link"
                        }`}
                        onClick={() => {
                          handleExternalSubmit();
                        }}
                      >
                        Attachments
                      </div>
                      <div
                        className="notification-count d-flex justify-content-center"
                        style={{ top: "3px", right: "-14px" }}
                      >
                        {attachmentCount}
                      </div>
                    </li>
                    {/* <li className="nav-item mx-3">
                      <div
                        role="button"
                        className={`${
                          tab === "notifications"
                            ? "nav-link active "
                            : "nav-link"
                        }`}
                        onClick={() => setTab("notifications")}
                      >
                        Notifications
                      </div>
                    </li> */}
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12 col-md-12 col-12">
              {/* Page header */}
              {/* <div className="mb-5">
                <h3 className="mb-0 ">Add Staff</h3>
              </div> */}
            </div>
          </div>
          <div>
            {/* row */}
            <div className="row">
              <div className="col-xl-12 col-md-12 col-12">
                {/* card */}
                {(() => {
                  switch (tab) {
                    case "information":
                      return (
                        <form onSubmit={handleSubmit(onSubmit)} ref={formRef}>
                          <div className="card mb-5">
                            {/* card body */}
                            <div className="card-body" style={{ padding: "10px" }}>
                              {/* form */}
                              {projectName && (
                                <div className="row">
                                  {/* form group */}
                                  <div className="mb-4 col-md-4 col-12">
                                    <label className="form-label">
                                      Project Name:
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      // placeholder="Enter ID"
                                      // {...register("TaskTmplID", {})}
                                      disabled
                                      value={projectName}
                                    />
                                  </div>
                                </div>
                              )}
                              <div className="row">
                                {/* form group */}
                                <div className="mb-4 col-md-4 col-12">
                                  <label className="form-label">
                                    Task Name:
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    // placeholder="Enter ID"
                                    // {...register("TaskTmplID", {})}
                                    disabled
                                    value={taskName}
                                  />
                                </div>
                              </div>
                              <div className="row">
                                <div className="mb-4 col-md-4 col-12">
                                  <label className="form-label">
                                    Ord No:{" "}
                                    {/* <span className="text-danger">*</span> */}
                                  </label>
                                  <input
                                    type="number"
                                    min="0"
                                    className="form-control"
                                    placeholder="Enter ord no"
                                    {...register("OrdNo", {
                                      // required: "Ord No is required",
                                    })}
                                  />
                                  {errors.OrdNo && (
                                    <div className="error">
                                      {errors.OrdNo.message}
                                    </div>
                                  )}
                                </div>
                                {/* form group */}
                                <div className="mb-4 col-md-8 col-12">
                                  <label className="form-label">
                                    Name <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter name"
                                    {...register("Name", {
                                      required: "Name is required",
                                      validate: validateNoBlankSpaces,
                                    })}
                                  />
                                  {errors.Name && (
                                    <div className="error">
                                      {errors.Name.message}
                                    </div>
                                  )}
                                </div>
                                {/* form group */}
                                {/* <div className="mb-4 col-md-5 col-12">
                                  <label className="form-label">Type</label>
                                  <select
                                    className="form-select"
                                    {...register("Type", {
                                      required: "Type is required",
                                    })}
                                  >
                                    <option value="">Set Type</option>
                                    {userTypeOption.map((item) => (
                                      <option value={item.id}>
                                        {item.value}
                                      </option>
                                    ))}
                                  </select>
                                  {errors.Type && (
                                    <div className="error">
                                      {errors.Type.message}
                                    </div>
                                  )}
                                </div> */}
                                {/* form group */}
                                <div className="mb-4 col-md-12 col-12">
                                  <label className="form-label">
                                    Description{" "}
                                    {/* <span className="text-danger">*</span> */}
                                  </label>
                                  <textarea
                                    type="text"
                                    rows={5}
                                    className="form-control"
                                    placeholder="Enter description"
                                    {...register("Dscr", {
                                      // required: "Description is required",
                                    })}
                                  ></textarea>
                                  {errors.Dscr && (
                                    <div className="error">
                                      {errors.Dscr.message}
                                    </div>
                                  )}
                                </div>

                                {/* form group */}
                                <div className="mb-4 col-md-3 col-6">
                                  <label className="form-label">
                                    Approx Days{" "}
                                    {/* <span className="text-danger">*</span> */}
                                  </label>
                                  <input
                                    type="number"
                                    min="0"
                                    className="form-control"
                                    placeholder="Enter Days"
                                    {...register("AprxDays", {
                                      // required: "Approx Days is required",
                                    })}
                                  />
                                  {errors.AprxDays && (
                                    <div className="error">
                                      {errors.AprxDays.message}
                                    </div>
                                  )}
                                </div>
                                {/* form group */}
                                <div className="mb-4 col-md-3 col-6">
                                  <label className="form-label">
                                    Approx Hours{" "}
                                    {/* <span className="text-danger">*</span> */}
                                  </label>
                                  <input
                                    type="number"
                                    min="0"
                                    className="form-control"
                                    placeholder="Enter Hours"
                                    {...register("AprxHours", {
                                      max: {
                                        value: 23,
                                        message:
                                          "approx hours must be less than 24",
                                      },
                                      // required: "Approx Hours is required",
                                    })}
                                  />
                                  {errors.AprxHours && (
                                    <div className="error">
                                      {errors.AprxHours.message}
                                    </div>
                                  )}
                                </div>
                                {/* form group */}
                                <div className="mb-4 col-md-3 col-6 ">
                                  <label className="form-label">
                                    Approx Minutes{" "}
                                    {/* <span className="text-danger">*</span> */}
                                  </label>
                                  <input
                                    type="number"
                                    min="0"
                                    className="form-control"
                                    placeholder="Enter Minutes"
                                    {...register("AprxMinutes", {
                                      max: {
                                        value: 59,
                                        message:
                                          "approx minutes must be less than 60",
                                      },
                                      // required: "Approx Minutes is required",
                                    })}
                                  />
                                  {errors.AprxMinutes && (
                                    <div className="error">
                                      {errors.AprxMinutes.message}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="mt-4 mb-4 d-flex justify-content-between">
                            <div className="left d-flex flex-wrap gap-3">
                              <div
                                className="  btn btn-outline-danger me-2"
                                onClick={() => {
                                  console.log(subtaskId);
                                  if (subtaskId) {
                                    navigate(
                                      `/update/task-template/${templateID}?subTaskId=${subtaskId}`
                                    );
                                  } else {
                                    navigate(
                                      `/update/task-template/${templateID}`
                                    );
                                  }

                                  reset();
                                }}
                              >
                                Cancel
                              </div>
                              <div className="  rounded-circl notification-count">
                                <div
                                  
                                  className="btn btn-dark me-2"
                                  onClick={() => handleExternalSubmit()}
                                >
                                  Attachments
                                </div>
                                <div className="notification-count d-flex justify-content-center">
                                  {attachmentCount}
                                </div>
                              </div>
                              {/* <div className="  rounded-circl notification-count">
                                <a
                                  href="#!"
                                  className="btn btn-dark me-2"
                                  onClick={() => setTab("notifications")}
                                >
                                  Notifications
                                </a>
                                <div className="notification-count">24</div>
                              </div> */}
                            </div>
                            <div className="right">
                              <button className="btn btn-primary  ">
                                Save
                              </button>
                            </div>
                          </div>
                        </form>
                      );

                    case "attachments":
                      return (
                        <Attachment
                          setTab={setTab}
                          setAttachmentCount={setAttachmentCount}
                          setTitle={setTitle}
                          attachmentType={"subTaskTemp"}
                          TranType={5}
                          AttchType={1}
                        />
                      );
                    case "notifications":
                      return <></>;
                    // case "attachments":
                    //   return <Attachments />;
                    // case "notifications":
                    //   return <Notifications />;
                    default:
                  }
                })()}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddUpdateSubTask;
